import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from "@angular/core";
import { TractorViewModel } from "@app/shared/models/tractors/TractorViewModel.model";

@Component({
  selector: "app-tractor-license",
  templateUrl: "./tractor-license.component.html",
  styleUrls: ["./tractor-license.component.css"],
})
export class TractorLicenseComponent implements OnInit, OnChanges {
  @Input() tractor: TractorViewModel;
  @Input() isEditMode: boolean;
  @Input() states: { abbreviation: string; fullName: string }[];
  @Input() dateInputMask: any;

  @Output() hasChanges = new EventEmitter<boolean>();

  private originalTractor: string;
  stateOptions: { label: string; value: string }[] = [];

  constructor() {}

  ngOnInit() {
    this.originalTractor = JSON.stringify(this.tractor);
    this.updateStateOptions();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["tractor"] && !changes["tractor"].firstChange) {
      this.originalTractor = JSON.stringify(this.tractor);
      this.checkForChanges();
    }
    if (changes["states"]) {
      this.updateStateOptions();
    }
  }

  updateStateOptions() {
    if (this.states) {
      this.stateOptions = this.states.map(state => ({
        label: state.fullName,
        value: state.abbreviation
      }));
    }
  }

  onFieldChange() {
    this.checkForChanges();
  }

  private checkForChanges() {
    const currentTractor = JSON.stringify(this.tractor);
    const changed = currentTractor !== this.originalTractor;
    this.hasChanges.emit(changed);
  }
}

